import { fork } from 'redux-saga/effects';
import qualification from './qualification';
import validation from './validation';

export default function* meSaga() {
  yield fork(qualification);
  yield fork(validation);
}
